import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { Column, Space, Txt } from '@stenajs-webui/core';
import { Icon, stenaBan, stenaExclamationTriangle } from '@stenajs-webui/elements';
import { cssColor } from '@stenajs-webui/theme';
import type { GraphQLError, GraphQLFormattedError } from 'graphql';
import type { FC } from 'react';
import { HttpError } from '../../../../common/error-handling/HttpError';
import { transformGraphqlError } from '../../../../common/error-handling/TransformGraphqlError';
import { Errors } from '../../../../common/texts';
import MissingBookingImage from '../../../../common-ui/images/missing_booking.svg?react';

export const BookingErrorModalContents: FC<{ icon?: IconDefinition }> = ({ icon }) => {
  return (
    <Column spacing={4} indent={4} alignItems={'center'}>
      {icon ? (
        <Icon size={120} icon={icon} color={cssColor('--lhds-color-blue-500')} />
      ) : (
        <MissingBookingImage height={134} width={124} />
      )}
      <Space num={4} />
      <Txt style={{ maxWidth: '380px' }}>{Errors.ContactLocalOfficeForBookingHelp}</Txt>
    </Column>
  );
};

export const BOOKING_ERROR_NOT_FOUND = { message: Errors.BookingNotFound, icon: undefined };
export const BOOKING_ERROR_FORBIDDEN = {
  icon: stenaBan,
  message: Errors.NoAccessToBooking,
};
export const BOOKING_ERROR_UNKNOWN = {
  icon: stenaExclamationTriangle,
  message: Errors.SomethingWentWrong,
};

export function getErrorModalContentFromGQLError(
  error: GraphQLError | GraphQLFormattedError | undefined,
) {
  if (!error) {
    return BOOKING_ERROR_NOT_FOUND;
  }

  const errorDetails = transformGraphqlError(error);

  switch (errorDetails.statusCode) {
    case HttpError.FileNotFound:
      return BOOKING_ERROR_NOT_FOUND;
    case HttpError.Forbidden:
      return BOOKING_ERROR_FORBIDDEN;
    case HttpError.InternalServerError:
    default:
      return BOOKING_ERROR_UNKNOWN;
  }
}
